import { devicesClient } from "@api/devices";

const initialState = () => ({
  devices: [],
  activeDevices: [],
  search:"",
  pagination: {
    pageNum: 1,
    pageSize: 10,
    totalCount: 0,
    rowsPerPageItems: [2, 10, 20, 30, 40, 50, 100]
  },
  promises: {
    deviceStatusFetchPromise: undefined,
    devicesFetchPromise: undefined,
    devicesDeletePromise: undefined,
    devicesSavePromise: undefined
  }
});

export default {
  namespaced: true,
  state: initialState(),
  getters: {
    list: state => state.devices,
    activeDevices: state => state.activeDevices,
    devicesFetching: state => state.promises.devicesFetchPromise !== undefined,
    devicesSaving: state => state.promises.devicesFetchPromise !== undefined,
    deviceDeleting: state => state.promises.devicesSavePromise !== undefined,
    pagination: state => state.pagination,
    search: state => state.search
  },
  mutations: {
    reset(state) {
      const initial = initialState();
      Object.keys(initial).forEach(k => {
        state[k] = initial[k];
      });
    },
    setDevices(state, { devices, totalCount }) {
      state.devices = devices;
      state.pagination.totalCount = totalCount;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setSearch(state, payload) {
      state.search = payload;
    },
    setActiveDevices(state, devices) {
      state.activeDevices = devices;
    },

    deleteDeviceBySerial(state, serial) {
      const index = state.devices.findIndex(x => x.serial === serial);
      if (index >= 0) {
        state.devices.splice(index, 1);
      } else throw Error(`Wrong device serial: ${serial}`);
    },
    devicesFetchPromise(state, promise) {
      state.promises.devicesFetchPromise = promise;
    },
    devicesSavePromise(state, promise) {
      state.promises.devicesSavePromise = promise;
    },
    devicesDeletePromise(state, promise) {
      state.promises.devicesDeletePromise = promise;
    },
    deviceStatusFetchPromise(state, promise) {
      state.promises.deviceStatusFetchPromise = promise;
    },
    videoListFetchingPromise(state, promise) {
      state.promises.videoListFetchingPromise = promise;
    }
  },
  actions: {
    getDevice(ctx, serial) {
      if (ctx.getters.devicesFetching) return;
      const promise = devicesClient
        .getDevice(serial)
        .then(resp => {
          ctx.commit("devicesFetchPromise", undefined);
          return resp;
        })
        .catch(error => {
          ctx.commit("devicesFetchPromise", undefined);
          throw error;
        });
      ctx.commit("devicesFetchPromise", promise);
      return promise;
    },
    addDevice(ctx, device) {
      if (ctx.getters.devicesSaving) return;
      const promise = devicesClient
        .postDevice(device)
        .then(resp => {
          ctx.commit("devicesSavePromise", undefined);
          return resp;
        })
        .catch(error => {
          ctx.commit("devicesSavePromise", undefined);
          throw error;
        });
      ctx.commit("devicesSavePromise", promise);
      return promise;
    },
    saveDevice(ctx, { serial, device }) {
      if (ctx.getters.devicesSaving) return;
      const promise = devicesClient
        .putDevice(serial, device)
        .then(resp => {
          ctx.commit("devicesSavePromise", undefined);
          return resp;
        })
        .catch(error => {
          ctx.commit("devicesSavePromise", undefined);
          throw error;
        });
      ctx.commit("devicesSavePromise", promise);
      return promise;
    },
    fetchDevices(ctx) {
      if (ctx.getters.devicesFetching) return;
      const { pageNum, pageSize } = ctx.state.pagination;
      const promise = devicesClient
        .getDevices(pageNum, pageSize)
        .then(resp => {
          const { devices, totalCount } = resp.data;
          ctx.commit("devicesFetchPromise", undefined);
          ctx.commit("setDevices", {
            devices,
            totalCount
          });
          return resp;
        })
        .catch(error => {
          ctx.commit("devicesFetchPromise", undefined);
          throw error;
        });
      ctx.commit("devicesFetchPromise", promise);
      return promise;
    },
    searchDevices(ctx) {
 
      if (ctx.getters.devicesFetching) return;
      const { pageNum, pageSize } = ctx.state.pagination;
      const q  = ctx.state.search; 
      const promise = devicesClient
        .searchDevices(q, pageNum, pageSize)
        .then(resp => {
          const { devices, totalCount } = resp.data;
          ctx.commit("devicesFetchPromise", undefined); 
          ctx.commit("setDevices", {
            devices,
            totalCount
          });
          return resp;
        })
        .catch(error => {
          ctx.commit("devicesFetchPromise", undefined);
          throw error;
        });
      ctx.commit("devicesFetchPromise", promise);
      return promise;
    },
    fetchActiveDevices(ctx) {
      if (ctx.getters.list.length === 0) return;
      const promise = devicesClient
        .getStatuses(ctx.getters.list.map(x => x.serial))
        .then(resp => {
          const { data } = resp;
          const activeDevices = Object.keys(data).filter(x => data[x] === 'ONLINE');
          ctx.commit("deviceStatusFetchPromise", undefined);
          ctx.commit("setActiveDevices", activeDevices);
          return resp;
        })
        .catch(error => {
          ctx.commit("deviceStatusFetchPromise", undefined);
          throw error;
        });
      ctx.commit("deviceStatusFetchPromise", promise);
      return promise;
    },
    deleteDevice(ctx, { serial }) {
      if (ctx.getters.deviceDeleting) return;
      const promise = devicesClient
        .deleteDevice(serial)
        .then(resp => {
          ctx.commit("devicesDeletePromise", undefined);
          ctx.commit("deleteDeviceBySerial", serial);
          return resp;
        })
        .catch(error => {
          ctx.commit("devicesDeletePromise", undefined);
          throw error;
        });
      ctx.commit("devicesDeletePromise", promise);
      return promise;
    },
    restoreDevice(ctx, { serial }) {
      if (ctx.getters.deviceDeleting) return;
      const promise = devicesClient
        .restoreDevice(serial)
        .then(resp => {
          ctx.commit("devicesDeletePromise", undefined);
          return resp;
        })
        .catch(error => {
          ctx.commit("devicesDeletePromise", undefined);
          throw error;
        });
      ctx.commit("devicesDeletePromise", promise);
      return promise;
    },

    xmlSend(ctx, { serial }) { 
      const promise = devicesClient
        .xmlSend(serial)
        .then(resp => {
          ctx.commit("devicesDeletePromise", undefined);
          return resp;
        })
        .catch(error => {
          ctx.commit("devicesDeletePromise", undefined);
          throw error;
        });
      ctx.commit("devicesDeletePromise", promise);
      return promise;
    }
  }
};



// WEBPACK FOOTER //
// ./src/state/devices-module.js